import { render, staticRenderFns } from "./popup-layer-demo.vue?vue&type=template&id=33e94309&scoped=true"
import script from "./popup-layer-demo.vue?vue&type=script&lang=js"
export * from "./popup-layer-demo.vue?vue&type=script&lang=js"
import style0 from "./popup-layer-demo.vue?vue&type=style&index=0&id=33e94309&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e94309",
  null
  
)

export default component.exports